import axios from './axios';

export const _login = (email: string, password: string) =>
  axios.post('/login', { email, password });

export const _profile = () => axios.get('/profile');
